import { Controller } from "@hotwired/stimulus"

// Search box and bulk select/clear for a long checkbox list (tagging 63 of 183
// members). Items carry data-name (lowercased); only shown items are affected.
export default class extends Controller {
  static targets = ["search", "item", "count", "empty"]

  connect() {
    this.updateCount()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let shown = 0

    this.itemTargets.forEach((item) => {
      const match = item.dataset.name.includes(query)
      item.classList.toggle("d-none", !match)
      if (match) shown++
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("d-none", shown > 0)
  }

  selectShown() {
    this.setShown(true)
  }

  clearShown() {
    this.setShown(false)
  }

  updateCount() {
    if (!this.hasCountTarget) return

    const checked = this.checkboxes().filter((checkbox) => checkbox.checked).length
    this.countTarget.textContent = `${checked} selected`
  }

  setShown(checked) {
    this.itemTargets
      .filter((item) => !item.classList.contains("d-none"))
      .forEach((item) => { item.querySelector("input[type=checkbox]").checked = checked })
    this.updateCount()
  }

  checkboxes() {
    return this.itemTargets.map((item) => item.querySelector("input[type=checkbox]"))
  }
}
